"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidLocale = void 0;
var FluidLocale;
(function (FluidLocale) {
    FluidLocale["DEFAULT"] = "DEFAULT";
    FluidLocale["UNITED_KINGDOM"] = "GB";
    FluidLocale["UNITED_STATES"] = "US";
    FluidLocale["CANADA"] = "CA";
    FluidLocale["FRANCE"] = "FR";
    FluidLocale["AUSTRALIA"] = "AU";
    FluidLocale["GERMANY"] = "DE";
    FluidLocale["SPAIN"] = "ES";
    FluidLocale["ITALY"] = "IT";
    FluidLocale["BRAZIL"] = "BR";
    FluidLocale["JAPAN"] = "JP";
    FluidLocale["MEXICO"] = "MX";
    FluidLocale["CHILE"] = "CL";
    FluidLocale["PERU"] = "PE";
    FluidLocale["BELGIUM"] = "BE";
    FluidLocale["PORTUGAL"] = "PT";
})(FluidLocale = exports.FluidLocale || (exports.FluidLocale = {}));
